import React from "react";

import { useSelector } from "react-redux";
import { ProtectedRoute } from "./ProtectedRoute";
import { RouteProps } from "react-router-dom";
import { StoreState } from "../store/types";

interface Props extends RouteProps {
  component: any;
}

export const AuthProtectedRoute: React.FC<Props> = ({
  component: Component,
  ...rest
}) => {
  const auth = useSelector<StoreState, boolean>((state) => state.token !== "");

  return (
    <ProtectedRoute
      component={Component}
      redirectRoute="/authentication/login"
      accessCondition={auth === true}
      {...rest}
    />
  );
};
